import { CalendarMonth, Collections, MarkAsUnread } from "@mui/icons-material";
import { Button, Divider, Grid, SwipeableDrawer, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ActionCard from "./ActionCard";

type SendGiftDrawerProps = {
  open: boolean;
  onOpen: () => void;
  onClose: () => void;
};

// "Reports" (View analytics, /report) is parked here until the analytics feature is built.
const actions = [
  {
    icon: <CalendarMonth className="size-8" />,
    title: "Calendar",
    details: "Plan ahead",
    path: "/calendar",
  },
  {
    icon: <Collections className="size-8" />,
    title: "Collections",
    details: "Browse gifts",
    path: "/collections",
  },
  {
    icon: <MarkAsUnread className="size-8" />,
    title: "Messages",
    details: "Read thank you notes",
    path: "/thanks-report",
  },
];

const SendGiftDrawer = ({ open, onOpen, onClose }: SendGiftDrawerProps) => {
  const navigate = useNavigate();

  const handleAction = (path: string) => {
    onClose();
    navigate(path);
  };

  return (
    <SwipeableDrawer
      anchor="bottom"
      open={open}
      onOpen={onOpen}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: { borderRadius: "16px 16px 0 0", px: 3, pb: 5, pt: 2, mx: 2 },
        },
      }}
    >
      {/* Drag handle */}
      <div className="flex justify-center mb-3">
        <div className="w-10 h-1 rounded-full bg-gray-300" />
      </div>

      <Typography variant="h6" className="font-semibold">
        Send a Gift
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        What do you want to do today?
      </Typography>

      <Divider sx={{ mb: 3 }} />

      <Grid container spacing={2} sx={{ mb: 3 }}>
        {actions.map((action) => (
          <Grid size={{ xs: 6 }} key={action.title}>
            <ActionCard
              icon={action.icon}
              title={action.title}
              details={action.details}
              onClick={() => handleAction(action.path)}
            />
          </Grid>
        ))}
      </Grid>

      <Button
        variant="outlined"
        fullWidth
        onClick={onClose}
        sx={{ borderRadius: 2 }}
        className="text-black border-gray-200"
      >
        Close
      </Button>
    </SwipeableDrawer>
  );
};

export default SendGiftDrawer;
